import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { DatePickerWrapperModule } from '@finder/shared/components/date-picker-wrapper/date-picker-wrapper.module';
import { FilterEmitterService } from '@finder/shared/services/filter-emitter-service/filter-emitter.service';
import { FilterButtonModule } from '@finder/shared/components/filters/components/filter-button/filter-button.module';
import { FilterPillsModule } from '@finder/shared/components/filters/components/filter-pills/filter-pills.module';
import { ButtonModule } from '@finder/shared/components/button/button.module';
import { InputModule } from '@finder/shared/components/input/input.module';
import { CalendarFiltersComponent } from './calendar-filters.component';
import { FontIconModule } from '@finder/shared/components/font-icon/font-icon.module';

const exportableComponents = [
    CalendarFiltersComponent
];

@NgModule({
    imports: [
        CommonModule,
        DatePickerWrapperModule,
        ButtonModule,
        FilterPillsModule,
        FilterButtonModule,
        InputModule,
        FontIconModule,
        FormsModule
    ],
    providers: [
        FilterEmitterService
    ],
    declarations: [
        exportableComponents,
    ],
    exports: [
        ...exportableComponents
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
})
export class CalendarsFiltersModule { }
